import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { pushBackHandler } from '@/app/backButton';

/**
 * Связывает системную кнопку «Назад» мессенджера с навигацией приложения.
 * Экран сообщает, куда возвращаться; если маршрут не указан, используется история.
 */
export function useBackButton(enabled: boolean, fallbackRoute?: string) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled) return undefined;

    return pushBackHandler(() => {
      if (fallbackRoute) navigate(fallbackRoute);
      else if (window.history.length > 1) navigate(-1);
      else navigate('/home');
    });
  }, [enabled, fallbackRoute, navigate]);
}
